import React, {Component} from "react";
import "./ClientNotifications.css";

class ClientNotifications extends Component {
    render() {
        return <p className="information">{this.props.notification}</p>
    }
}

export default ClientNotifications;